import { throwErrorWithId } from '@pypestream/utils';

import {
  getProjectChannels,
  getPypeRuleGroups,
  type Channel,
  type RuleSet,
} from '../../utils';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';

/**
 * Loads every masking rule set for the current project (Data Privacy page),
 * plus the project's channels so each rule set can show which channels use it.
 */
export const loadPypeRuleGroups = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{ pypeRuleGroups: RuleSet[]; channels: Channel[] } | void> => {
  if (event.type !== 'loadPypeRuleGroups') {
    return;
  }

  const projectId = ctx.project?.id;
  const uniqueCustomerId = ctx.project?.projectProStudioSetting?.customerId;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  const [pypeRuleGroups, channels] = await Promise.all([
    getPypeRuleGroups({ projectId }),
    uniqueCustomerId
      ? getProjectChannels({ uniqueCustomerId, projectId })
      : Promise.resolve<Channel[]>([]),
  ]);

  return { pypeRuleGroups, channels };
};
